import React, { useEffect, useState } from "react";
import { TableLoader, TableModel } from "../../components/tableLoader/index.js";
import { useSelector } from "react-redux";
import ModalStatementDetail from "../../components/modalStatementDetail/ModalStatementDetail.jsx";
export { Statements };

function Statements({}) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [selectedHistoryId, setSelectedHistoryId] = useState(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const [approvalDate, setApprovalDate] = useState(null);
  const [reportUrl, setReportUrl] = useState(null);
  const loader = {
    title: "Заявление о выборе элективных дисциплин",
    icon: "survey",
    request: {
      method: "post",
      path: "/student/elective_discips/statements/list",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    setReportUrl(response.curriculum_report_url);
    const table = new TableModel(response);
    table.columns.forEach((element) => {
      if (element.field === "approval_date") {
        element.type = "date";
        element.sortable = true;
      }
      if (element.field === "selected_history_id") {
        element.type = "link";
      }
    });
    table.rows = table.rows.map((row) => ({
      ...row,
      selected_history_id: {
        name: "Смотреть заявление",
        href: "#" + row.selected_history_id,
        onClick: () => {
          setSelectedHistoryId(row.selected_history_id);
          setIsShowModal(true);
          setApprovalDate(row.approval_date);
        },
      },
    }));
    return table;
  }
  const menu = [
    {
      name: "Смотреть учебный план",
      href: reportUrl,
      icon: "none",
      target: "blank",
    },
  ];
  return (
    <>
      <TableLoader {...loader} menu={menu} />
      {isShowModal && (
        <ModalStatementDetail
          selectedHistoryId={selectedHistoryId}
          setIsShowModal={setIsShowModal}
          approvalDate={approvalDate}
        />
      )}
    </>
  );
}
